module.exports = __webpack_public_path__ + "static/circadian-algorithm-c2bce75bbe2ec86b1aee7151b281a8a4.png";